import CreatableSelect from "react-select/creatable";
import { useState } from "react";

import CheckBox from "../Form/Checkbox";
import Textarea from "@mui/joy/Textarea";
import Box from "@mui/material/Box";

import { useDispatch } from "react-redux";
import { addDocumentType, getDocumentTypes } from "../../app/actions/documents";

const thumb = {
  display: "inline-flex",
  borderRadius: 2,
  border: "1px solid #eaeaea",
  marginBottom: 8,
  marginRight: 8,
  width: 100,
  height: 100,
  padding: 4,
  boxSizing: "border-box",
};

const thumbInner = {
  display: "flex",
  minWidth: 0,
  overflow: "hidden",
};

const img = {
  display: "block",
  width: "auto",
  height: "100%",
};

const DocumentItem = ({
  id,
  file,
  documentTypes,
  name,
  description,
  onDelete,
  onChange,
}) => {
  const dispatch = useDispatch();
  const [value, setValue] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const allowedTypes = ["image/jpeg", "image/png", "image/gif"];
  const preview = allowedTypes.includes(file?.type)
    ? URL.createObjectURL(file)
    : null;

  const onCreate = (name) => {
    setIsLoading(true);
    dispatch(addDocumentType(name)).then((type) => {
      dispatch(getDocumentTypes()).then(() => setIsLoading(false));
      onChange(id, "type", type.id);
      setValue({ value: type.id, label: type.name });
    });
  };
  return (
    <Box
      key={id}
      sx={{
        "& .file-item > :not(style)": { m: 2 },
      }}
    >
      <li key={file.path} className="file-item ">
        <label className="blue">
          {file.path} - {file.size} bytes
        </label>
        {preview && (
          <div style={thumb} key={preview}>
            <div style={thumbInner}>
              <img
                src={preview}
                style={img}
                // Revoke data uri after image is loaded
                onLoad={() => {
                  URL.revokeObjectURL(preview);
                }}
              />
            </div>
          </div>
        )}
        <CreatableSelect
          isClearable
          isDisabled={isLoading}
          isLoading={isLoading}
          options={documentTypes}
          onCreateOption={onCreate}
          onChange={(selectedData) => {
            onChange(id, "type", selectedData?.value);
            setValue(selectedData);
          }}
          value={value}
        />
        <Textarea
          placeholder="Comments"
          minRows={3}
          onChange={(e) => onChange(id, "comments", e.target.value)}
        />
        {allowedTypes.includes(file?.type) && (
          <CheckBox
            label="Treat As Document"
            onChange={(e) => {
              onChange(id, "treatAsDocument", e.target.checked);
            }}
          />
        )}
      </li>
    </Box>
  );
};

export default DocumentItem;
